import { DatesRangeType } from 'enums';
import { FilterElementProps } from 'utils';
import { HotjarEvents } from 'utils/hotjar-events';
import useSubmissionFilter from 'broker/components/SubmissionsView/useSubmissionFilter';
import { submissionDatesRangeConfig } from 'broker/configuration-mappers/submission-dates-range-type-config';
import { queueStorageKeys } from './config';

const baseDatesRangeFiltersList: FilterElementProps[] = Object.values(DatesRangeType).map((type) => ({
  key: type,
  checked: false,
  label: submissionDatesRangeConfig[type].text,
}));

interface UseEffectiveDateFilterProps {
  paginationReset: () => void;
}

export function useEffectiveDateFilter({ paginationReset }: UseEffectiveDateFilterProps) {
  return useSubmissionFilter({
    baseFiltersList: baseDatesRangeFiltersList,
    storageKey: queueStorageKeys.effectiveDate,
    hotjarEvent: HotjarEvents.SubmissionsDatesRangeFilter,
    paginationReset,
  });
}
